// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__318pr","clinicsSelect":"styles_clinicsSelect__3SuRC"};